// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const npwp: CountryValidator<"ID"> = createValidator(
  "id.npwp",
  93,
);

export default npwp;
export const compact = npwp.compact;
export const format = npwp.format;
export const validate = npwp.validate;
export const generate = (): string =>
  npwp.generate?.() ??
  (() => {
    throw new Error(
      "Validator id.npwp cannot generate values",
    );
  })();
